<i18n>
{
  "zh": {
    "all": "所有",
    "allShapes": "所有形状",
    "allConnector": "所有连接线",
    "allImages": "所有图片",
    "allGuideLines": "所有参考线",
    "selByLayer": "按图层选中",
    "selByShapes": "同类型形状",
    "selByLines": "同类型连接线",
    "excludeBySel": "从选择中排除"
  },
  "en": {
    "all": "All",
    "allShapes": "All shapes",
    "allConnector": "All connection lines",
    "allImages": "All images",
    "allGuideLines": "All reference lines",
    "selByLayer": "Select by Layer",
    "selByShapes": "Same type of shape",
    "selByLines": "Same type connecting line",
    "excludeBySel": "Exclude from selection"
  },
  "fr": {
    "all": "tout",
    "allShapes": "Toutes formes",
    "allConnector": "Toutes les lignes de connexion",
    "allImages": "Toutes les photos",
    "allGuideLines": "Toutes les lignes de référence",
    "selByLayer": "Sélectionnez par couche",
    "selByShapes": "Même type de forme",
    "selByLines": "Même type de ligne de connexion",
    "excludeBySel": "Exclusion de la sélection"
  },
  "de": {
    "all": "Alles",
    "allShapes": "Alle Formen",
    "allConnector": "Alle Verbindungsleitungen",
    "allImages": "Alle Bilder",
    "allGuideLines": "Alle Referenzlinien",
    "selByLayer": "Nach Ebene auswählen",
    "selByShapes": "Gleiche Form",
    "selByLines": "Verbindungsleitung vom gleichen Typ",
    "excludeBySel": "Aus der Auswahl ausschließen"
  },
  "jp": {
    "all": "すべて",
    "allShapes": "すべての形",
    "allConnector": "すべての接続線",
    "allImages": "すべての写真",
    "allGuideLines": "すべての参照線",
    "selByLayer": "レイヤーで選択",
    "selByShapes": "同型形状",
    "selByLines": "同じタイプの接続線",
    "excludeBySel": "選択から除外する"
  },
  "es": {
    "all": "todas",
    "allShapes": "Todas las formas",
    "allConnector": "Todas las líneas de conexión",
    "allImages": "Todas las imágenes",
    "allGuideLines": "Todas las líneas de referencia",
    "selByLayer": "Seleccionar por capa",
    "selByShapes": "Mismo tipo de forma",
    "selByLines": "Mismo tipo de línea de conexión",
    "excludeBySel": "Excluir de la selección"
  },
  "pt": {
    "all": "tudo",
    "allShapes": "Todas as formas",
    "allConnector": "Todas as linhas de conexão",
    "allImages": "Todas as fotos",
    "allGuideLines": "Todas as linhas de referência",
    "selByLayer": "Selecione por camada",
    "selByShapes": "Forma do mesmo tipo",
    "selByLines": "Linha de conexão do mesmo tipo",
    "excludeBySel": "Excluir Da seleção"
  },
  "it": {
    "all": "tutti",
    "allShapes": "Tutte le forme",
    "allConnector": "Tutte le linee di collegamento",
    "allImages": "Tutte le immagini",
    "allGuideLines": "Tutte le linee di riferimento",
    "selByLayer": "Seleziona per livello",
    "selByShapes": "Stesso tipo di forma",
    "selByLines": "Stesso tipo di linea di collegamento",
    "excludeBySel": "Esclusi dalla selezione"
  },
  "tw": {
    "all": "所有",
    "allShapes": "所有形狀",
    "allConnector": "所有連接線",
    "allImages": "所有圖片",
    "allGuideLines": "所有參考線",
    "selByLayer": "按圖層選中",
    "selByShapes": "同類型形狀",
    "selByLines": "同類型連接線",
    "excludeBySel": "從選擇中排除"
  }
}
</i18n>
<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" @handleMouseenter="handleMouseenter(...arguments)" :showTippy="false" />
</template>
<script lang="ts">
    import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    enum tabType {
        file,
        edit,
        select,
        insert,
        arrange,
        view,
        help,
        symbol,
    }

    const KeyMapKey = {
        selectLayer: "selByLayer",
        selectShapes: "selByShapes",
        selectLines: "selByLines",
        excludeSel: "excludeBySel",
    };

    @Component({
        components: {
            MenuList,
        },
    })
    export default class FileDrops extends Vue {
        activeKey = "";

        get isActived() {
            return this.$store.state.shape.isActived;
        }
        get isActiveShape() {
            return (
                this.isActived &&
                !this.$store.state.shape.isLine &&
                !this.$store.state.shape.isAllMMShape &&
                !this.$store.state.shape.isIgnJump &&
                !(this.$store.state.shape.type === "Image") &&
                !this.$store.state.shape.isMultiSel &&
                !(this.$store.state.shape.type === "Group")
            );
        }
        get isActiveLine() {
            // return window['_view']._activeShape && window['_view']._activeShape.isConnector();
            return this.$store.state.shape.isActived && this.$store.state.shape.type === "ConnectLine" && !this.$store.state.shape.isMultiSel;
        }
        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        get menuList() {
            let list = [
                {
                    key: "all",
                    shortcut: "Ctrl + A",
                    extraClass: this.activeFunc == "selectAll" && "activeFunc",
                },
                {
                    key: "allShapes",
                    disabled: this.disableShape,
                    extraClass: this.activeFunc == "selectAllShapes" && "activeFunc",
                },
                {
                    key: "allConnector",
                    disabled: this.disableConnector,
                    extraClass: this.activeFunc == "selectAllLines" && "activeFunc",
                },
                {
                    key: "allImages",
                    disabled: this.disableImg,
                    extraClass: this.activeFunc == "selectAllImages" && "activeFunc",
                },
                {
                    key: "allGuideLines",
                    disabled: this.disableGuideLine,
                    extraClass: this.activeFunc == "selectAllGuideLines" && "activeFunc",
                },
                {
                    key: "selByLayer",
                    expand: true,
                    active: false,
                    extraClass: this.activeFunc == "selectByLayer" && "activeFunc",
                },
                {
                    key: "selByShapes",
                    expand: true,
                    active: false,
                    disabled: !this.isActiveShape,
                    extraClass: this.activeFunc == "selectByShape" && "activeFunc",
                },
                {
                    key: "selByLines",
                    expand: true,
                    active: false,
                    disabled: !this.isActiveLine,
                    extraClass: this.activeFunc == "selectByLines" && "activeFunc",
                },
                {
                    key: "excludeBySel",
                    expand: true,
                    active: false,
                    disabled: !this.isMultiSel,
                    extraClass: this.activeFunc == "selectExclude" && "activeFunc",
                },
            ];
            list.forEach((v) => {
                if ("active" in v) {
                    v.active = this.activeKey === v.key;
                }
            });
            let resultList = [];
            list.map((item) => {
                resultList.push(Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "select-drops", list: resultList };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "all",
                    () => {
                        event.stopPropagation();
                        this.selectByType("all");
                    },
                ],
                [
                    "allShapes",
                    () => {
                        event.stopPropagation();
                        this.selectByType("shape");
                    },
                ],
                [
                    "allConnector",
                    () => {
                        event.stopPropagation();
                        this.selectByType("connector");
                    },
                ],
                [
                    "allImages",
                    () => {
                        event.stopPropagation();
                        this.selectByType("img");
                    },
                ],
                [
                    "allGuideLines",
                    () => {
                        event.stopPropagation();
                        this.selectByType("guideline");
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.activeKey = KeyMapKey[key];
            this.showExpand(event, key);
        }
        selectByType(type) {
            let view = window["_view"];
            switch (type) {
                case "all":
                    view.selectAll();
                    this.$track("select", "selectall", "all");
                    break;
                case "connector":
                    view.selAllConnectors();
                    this.$track("select", "selectall", "allline");
                    break;
                case "shape":
                    view.selectAllShapes();
                    this.$track("select", "selectall", "allshapes");
                    break;
                case "img":
                    view.selectAllImages();
                    this.$track("select", "selectall", "allimage");
                    break;
                case "guideline":
                    view.selectAllGuideLines();
                    this.$track("select", "selectall", "reference line");
                    break;
            }
            this.$emit("closeDrop");
        }
        disableConnector = true; // 页面是否存在连接线
        disableShape = true; // 页面是否存在形状
        disableImg = true; // 页面是否存在图片
        disableGuideLine = true; //页面是否存在参考线

        showExpand(e: MouseEvent, type: string) {
            let node = <HTMLElement>e.target;
            let scrollTop = node.parentElement.scrollTop;
            let ts: any = this;
            ts.$bus.$emit("changeDropType", type, node.offsetTop - scrollTop);
            if (["selectLayer", "selectShapes", "selectLines", "excludeSel"].includes(type)) {
                this.$store.commit("setStatus", {
                    type: "showDropExpand",
                    data: true,
                });
            }
        }

        get showDropdown() {
            return this.$store.state.ui.showDropdown;
        }
        get dropType() {
            return this.$store.state.ui.dropType;
        }
        @Watch("showDropdown", { immediate: true })
        watchDropType(val) {
            if (this.dropType == tabType.select && this.showDropdown) {
                let view = window["_view"];
                this.disableConnector = view._activePage?.hasConnector();
                this.disableShape = view._activePage?.hasShape();
                this.disableImg = view._activePage?.hasImg();
                this.disableGuideLine = view._activePage?.hasGuideLine();
            }
            if (!val) {
                this.activeKey = "";
            }
        }
        created() {}
        deactivated() {
            this.activeKey = "";
        }
    }
</script>
